import { z } from 'zod';

import { requestersFieldName } from './RequestersStep.constants';

export const schema = z.object({
    [requestersFieldName]: z.array(z.string()).nonempty(),
});
